import React, { useState } from 'react';
import YouTubeSearch from './YouTubeSearch';
import WebVideoPlayer from './OtakustvPlayer';

interface VideoSourceSelectorProps {
  onVideoSelect: (videoUrl: string) => void;
}

const VideoSourceSelector: React.FC<VideoSourceSelectorProps> = ({ onVideoSelect }) => {
  const [activeTab, setActiveTab] = useState<'youtube' | 'webvideo'>('youtube');

  return (
    <div className="bg-gradient-to-br from-gray-900/90 to-gray-800/80 backdrop-blur-sm rounded-xl border border-gray-700/30 overflow-hidden">
      {/* Pestañas */}
      <div className="flex border-b border-gray-700/30">
        <button
          className={`flex-1 py-3 px-4 font-medium flex items-center justify-center transition-all duration-300 ${
            activeTab === 'youtube'
              ? 'text-red-400 border-b-2 border-red-500'
              : 'text-gray-400 hover:text-gray-300'
          }`}
          onClick={() => setActiveTab('youtube')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-red-500" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
          </svg>
          YouTube
        </button>
        <button
          className={`flex-1 py-3 px-4 font-medium flex items-center justify-center transition-all duration-300 ${
            activeTab === 'webvideo'
              ? 'text-blue-400 border-b-2 border-blue-500'
              : 'text-gray-400 hover:text-gray-300'
          }`}
          onClick={() => setActiveTab('webvideo')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-400" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
          </svg>
          Web Video
        </button>
      </div>

      {/* Contenido según la pestaña activa */}
      <div className="transition-all duration-300">
        {activeTab === 'youtube' ? (
          <YouTubeSearch onVideoSelect={onVideoSelect} />
        ) : (
          <WebVideoPlayer onVideoSelect={onVideoSelect} />
        )}
      </div>
    </div>
  );
};

export default VideoSourceSelector; 